import React from 'react';
import { Role } from '../../../../shared/services/userService';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface UserFiltersProps {
  searchTerm: string;
  selectedRole: number | '';
  roles: Role[];
  onSearchChange: (value: string) => void;
  onRoleChange: (value: number | '') => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  searchTerm,
  selectedRole,
  roles,
  onSearchChange,
  onRoleChange
}) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  return (
    <div className="rounded-xl border border-[#243052]/90 bg-[#0d152b]/90 p-4 backdrop-blur-sm mb-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            {t('filters.search')}
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={t('filters.searchPlaceholder')}
            className="w-full rounded-lg border border-[#2a3a62] bg-[#0a132b] px-3 py-2 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-[#3d4fdb]/60"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            {t('filters.role')}
          </label>
          <select
            value={selectedRole}
            onChange={(e) => onRoleChange(e.target.value ? Number(e.target.value) : '')}
            className="w-full rounded-lg border border-[#2a3a62] bg-[#0a132b] px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-[#3d4fdb]/60"
          >
            <option value="">{t('filters.allRoles')}</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.role_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;
